var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "process-bar",
      style: { height: _vm.selectorHeight + "px" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "process-window" }, [
          _c("div", { staticClass: "process-percentage" }, [
            _c("span", { staticClass: "percentage-value" }, [
              _vm._v(_vm._s(_vm.percentage))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "percentage-symbol" }, [_vm._v("%")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "process-text" }, [
            _c("span", [_vm._v(_vm._s(_vm.text))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bar-container" }, [
            _c("div", {
              staticClass: "bar-value",
              style: { width: _vm.percentage + "%" }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9313cc10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9313cc10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notebook/ProcessBar.vue
// module id = null
// module chunks = 